import { getBrandProfileV2, getCurrentColorPaletteV1, getTypographyPreferences, getLogoCore, listFontCatalog, getLatestBrandStory, getLatestBrandPortrait, getBrandCreationPriorities, listBrandReferences, getStructuredVisualStyle } from './brandStudioApi';

// Shared read-only input for MB1 readiness. No new persistence or statuses.
const reads = { profile:getBrandProfileV2, palette:getCurrentColorPaletteV1, typography:getTypographyPreferences, core:getLogoCore, catalog:listFontCatalog, story:getLatestBrandStory, portrait:getLatestBrandPortrait, priorities:getBrandCreationPriorities, references:listBrandReferences, visualStyle:getStructuredVisualStyle };
export async function readBrandWorkspaceSourcesV1() {
  const readEntry=async ([key,read])=>{
    try { return [key,await read()]; }
    catch (failure) { if(failure?.response?.status===404 && key!=='catalog') return [key,null]; throw failure; }
  };
  const initial=Object.fromEntries(await Promise.all(['profile','story','portrait'].map(key=>readEntry([key,reads[key]]))));
  // Profile-dependent reads conflict for an account that has not started yet.
  if(!initial.profile) return {...initial,catalog:[]};
  const rest=await Promise.all(Object.entries(reads).filter(([key])=>!['profile','story','portrait'].includes(key)).map(readEntry));
  return {...initial,...Object.fromEntries(rest)};
}
